import React from 'react';

const ClearGroupSelectIcon = () => {
	return (
		<svg
			data-testid='clear-group-select'
			fill='none'
			height='8'
			viewBox='0 0 8 8'
			width='8'
		>
			<path
				d='M3.50257 4L2.69733e-06 0.499602L0.499914 0L4 3.49792L7.50009 0L8 0.499602L4.49743 4L8 7.5004L7.50008 8L4 4.50208L0.499911 8L0 7.5004L3.50257 4Z'
				fill='#2E2E6B'
			/>
		</svg>
	);
};

export default ClearGroupSelectIcon;
